module.exports = global["jstz"] = require("-!./jstz.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?jstz!../apps/chide/products/smapply/static/vendor/jstz.js-exposed
// module id = 1438
// module chunks = 17